import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const SettingsApiKeysPage = lazy(() => import('@/pages/settings/api-keys'));

export const Route = createFileRoute('/settings/api-keys')({
  component: function SettingsApiKeysRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <SettingsApiKeysPage />
      </Suspense>
    );
  },
});
